import { useEditor } from '@smartfire/js-block-engine'
import clsx from 'clsx'
import dayjs from 'dayjs'
import React from 'react'
import { AccessPrice, LocationDate } from '../../../components'
import { useMediaQuery } from '../../../hooks'
import { postEventsParams } from '../../../types'
import style from './style.module.scss'

export enum mobileType {
    classic = 'CLASSIC',
    archive = 'ARCHIVE',
    minify = 'MINIFY',
}

export const EventTile: React.FC<{ post: postEventsParams; mobile?: mobileType }> = ({
    post,
    mobile = mobileType.classic,
}) => {
    const { isEditing } = useEditor()
    const isMobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')

    const imageTag = isMobile ? post.thumbnail_mobile?.tag : post.thumbnail.tag

    return (
        <div className={clsx(style.block, style[mobile], isEditing ? style.admin : undefined)}>
            <div className={style.top}>
                <a href={post.link} className={style.imageContainer}>
                    {imageTag && <picture dangerouslySetInnerHTML={{ __html: imageTag }} />}

                    {(!isMobile || mobile !== mobileType.minify) && (
                        <LocationDate
                            classNames={[style.forTile]}
                            location={post?.location}
                            place={post?.place}
                            date={post?.eventDate}
                        />
                    )}
                </a>

                <div className={style.content}>
                    {mobile === mobileType.minify && isMobile && (
                        <LocationDate
                            classNames={[style.forTile]}
                            location={post?.location}
                            place={post?.place}
                            date={post?.eventDate}
                        />
                    )}

                    <div className={style.taxs}>
                        {post.parentTax && (
                            <a className={style.ptax} href={post.parentTax.link}>
                                {post.parentTax.name}
                            </a>
                        )}
                        {post.tax && post.parentTax && '/'}
                        {post.tax && (
                            <a className={style.ctax} href={post.tax.link}>
                                {post.tax.name}
                            </a>
                        )}
                    </div>

                    <a className={style.title} href={post.link}>
                        {post.title}
                    </a>

                    <a
                        className={style.excerpt}
                        href={post.link}
                        dangerouslySetInnerHTML={{ __html: post.excerpt }}
                    />
                </div>
            </div>

            <div className={style.bottomContainer}>
                <div className={style.bottom}>
                    <p className={style.date}>{dayjs(post.date).format('DD MMM YYYY')}</p>

                    <AccessPrice
                        classNames={[style.price]}
                        access={post?.access}
                        price={post?.price}
                        forTile
                    />
                </div>
            </div>
        </div>
    )
}
